import { palette } from '@/theme/constants';
export const styles = {
  divider: {
    border: `0.063rem solid ${palette.gray}`,
    margin: '1rem 0rem',
    width: '100%',
  },
};
